module.exports = __webpack_public_path__ + "media/images/shark/Shark2-p-800-30a4b96c912f33b822b7a72701fe9fd9.png";